export default __webpack_public_path__ + "media/images/banners/months/bnr_9-1231818a28e845899a89c3a91f38ade3.jpg";